import { z } from 'zod';

/** A public, approved review shown on the storefront product page. */
export interface StorefrontReview {
  id: string;
  name: string;
  rating: number;
  comment: string | null;
  createdAt: string;
}

/** Rating summary + recent approved reviews for a product. */
export interface StorefrontReviewSummary {
  average: number;
  count: number;
  items: StorefrontReview[];
}

/** Public submission payload (moderated before it shows). */
export const ReviewSubmitSchema = z.object({
  name: z.string().trim().min(1).max(120),
  rating: z.number().int().min(1).max(5),
  comment: z.string().trim().max(2000).optional(),
});
export type ReviewSubmit = z.infer<typeof ReviewSubmitSchema>;

/** Staff moderation view of a review. */
export interface CmsReview {
  id: string;
  itemId: string;
  itemName: string | null;
  name: string;
  rating: number;
  comment: string | null;
  isApproved: boolean;
  createdAt: string;
}
